import FieldsTranslation from "graphql/fields/FieldsTranslation";

export default `
	guid
	updated_at
	name
	default
	position
	active
	
	translations {
		${FieldsTranslation}
	}
`;
